export const getEventNameAntePost = (sel) => {
    return {
        sportName: sel.sportName,
        leagueName: `${sel.leagueName} - ${sel.eventDisplayName}`
    };
};
//# sourceMappingURL=getEventNameAntePost.js.map